import { render, staticRenderFns } from "./registrationInfo.vue?vue&type=template&id=d4ce5a68"
import script from "./registrationInfo.vue?vue&type=script&lang=js"
export * from "./registrationInfo.vue?vue&type=script&lang=js"
import style0 from "./registrationInfo.vue?vue&type=style&index=0&id=d4ce5a68&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports